import type { UnifiedLearningAssetTypeValue } from '~/types/unifiedLearningAsset';

import { LearningAssetType } from '~/graphql/generated/graphql';

const learningAssetTypeMap: Partial<Record<LearningAssetType, UnifiedLearningAssetTypeValue>> = {
  [LearningAssetType.StoryAsset]: LearningAssetType.StoryAsset,
  [LearningAssetType.Industry]: LearningAssetType.StoryAsset,
  [LearningAssetType.Pathway]: LearningAssetType.Pathway,
};

export const learningAssetTypeTransformer = (learningAssetType: LearningAssetType | undefined): UnifiedLearningAssetTypeValue => {
  if (!learningAssetType) {
    throw new Error(`learningAssetTypeTransformer: learningAssetType is undefined`);
  }

  const unified = learningAssetTypeMap[learningAssetType];

  if (!unified) {
    throw new Error(`learningAssetTypeTransformer: unsupported type "${learningAssetType}"`);
  }

  return unified;
};
